
export const manifestoTranslations = {
  manifestoTitle: {
    fr: "Le manifeste",
    en: "The manifesto"
  },
  manifestoQuote: {
    fr: "\"L'Algérie a besoin de ses leaders. Ses leaders ont besoin les uns des autres.\"",
    en: "\"Algeria needs its leaders. Its leaders need each other.\""
  },
  manifestoParagraph1: {
    fr: "First Tuesday est né d'une conviction profonde : l'Algérie de demain se construit aujourd'hui par l'intelligence collective de ses faiseurs. Chaque premier mardi du mois, pas de mondanités, pas de réseautage superficiel. Seulement l'action collaborative au service du pays.",
    en: "First Tuesday was born from a deep conviction: tomorrow's Algeria is built today through collective intelligence of its makers. Every first Tuesday of the month, no social events, no superficial networking. Only collaborative action in service of the country."
  },
  manifestoParagraph2: {
    fr: "Chaque premier mardi à Alger, nous rassemblons les acteurs du changement algériens et sa diaspora mondiale dans un cercle bienveillant d'échange et d'action. Entrepreneurs, dirigeants, investisseurs et experts - tous ceux qui construisent - se retrouvent pour développer ensemble l'Algérie.",
    en: "Every first Tuesday in Algiers, we bring together Algerian change makers and its global diaspora in a benevolent circle of exchange and action. Entrepreneurs, leaders, investors and experts - all those who build - come together to develop Algeria."
  },
  manifestoParagraph3: {
    fr: "Notre mission est claire : créer la première plateforme d'intelligence collective au service de l'Algérie et de son développement. Si vous portez l'Algérie dans votre cœur et êtes un faiseur dans l'action, First Tuesday est fait pour vous.",
    en: "Our mission is clear: create the first collective intelligence platform in service of Algeria and its development. If you carry Algeria in your heart and are a maker in action, First Tuesday is for you."
  }
};
